import useVehicleSubscriptions from './useVehicleSubscriptions';

const useVehicleSubscription = (_id?: string) => {
  const query = useVehicleSubscriptions();
  return query;
};

export default useVehicleSubscription;
